<template>
    <div class="container">
        <div style="height: 5em;"></div>

        <div class="head-box dark">
            <h1 style="padding-top:10px">{{ $t('head_news') }}</h1>
        </div>

        <div class="waterfall-container">
            <div class="news-card waterfall-item" v-for="(news, index) in news_data" :key="index">
                <div calss="content">
                    <img class="img__ uipack-img" v-lazy="news.img_url" style="width:95%;border-radius:14px;margin:3% 0">
                    <p><span class="ui-badge ui-dark">{{ news.time }}</span></p>
                    <h3 v-html="news.title"></h3>
                    <p style="padding: 1em" v-html="news.description"></p>
                    <!--ui-rounded-->
                    <a class="ui-news-btn ui-rounded" v-if="news.button_link !== 'none'" :href="news.button_link" target="_blank" style="margin-bottom:1.28em;">
                        <span v-if="news.button_text !== undefined">{{news.button_text}}</span>
                        <span v-else>{{ $t('download') }}</span>
                    </a>
                </div>
            </div>
        </div>
        <div style="height:50px"></div>
    </div>
</template>

<script>
//import news_api from '../../public/api//news.json'
export default {
    data () {
        return {
            news_data: null
        }
    },
    watch: {
        "$i18n.locale": function (lang) {
            // eslint-disable-next-line
            axios.get('/api/' + lang + '/news.json')
                .then((response) => {
                    this.news_data = response.data.news;
                })
        }
    },
    mounted () {
        //this.news_data = news_api.news;
        var lang = this.$i18n.locale
        if(lang === null){
            lang = 'en'
        }

        // eslint-disable-next-line
        axios.get('/api/' + lang + '/news.json')
            .then((response) => {
                this.news_data = response.data.news;
            })

    }
}
</script>